import { useState, useEffect } from 'react';

/**
 * Custom hook for Social Media metrics
 * Tracks followers, traffic, and booked calls across platforms
 */
export const useSocialMedia = (dateRange) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    setError(null);

    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 800));

      // Mock data for social media platforms
      const mockData = {
        platforms: {
          linkedin: {
            name: 'LinkedIn',
            followers: 12450,
            trafficToSite: 3240,
            bookedCalls: 18,
            followersChange: 8.5,
            trafficChange: 12.3,
            callsChange: 20.0,
          },
          instagramPersonal: {
            name: 'Instagram Personal',
            followers: 8920,
            trafficToSite: 1840,
            bookedCalls: 7,
            followersChange: 5.2,
            trafficChange: 8.7,
            callsChange: 16.7,
          },
          instagramBusiness: {
            name: 'Instagram Business',
            followers: 15680,
            trafficToSite: 2950,
            bookedCalls: 12,
            followersChange: 6.8,
            trafficChange: 10.5,
            callsChange: 9.1,
          },
          tiktok: {
            name: 'TikTok',
            followers: 24500,
            trafficToSite: 4120,
            bookedCalls: 9,
            followersChange: 22.4,
            trafficChange: 35.2,
            callsChange: 12.5,
          },
          youtube: {
            name: 'YouTube',
            followers: 6780,
            trafficToSite: 2180,
            bookedCalls: 14,
            followersChange: 4.1,
            trafficChange: 6.8,
            callsChange: 27.3,
          },
        },
        summary: {
          totalFollowers: 68330,
          totalTraffic: 14330,
          totalBookedCalls: 60,
        },
      };

      setData(mockData);
    } catch (err) {
      setError(err.message || 'Failed to fetch social media data');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const refetch = () => fetchData(true);

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
};